import { z } from '@betty/toolkit/api';
import { PaymentProviderSchema } from '../PaymentService/PaymentService.schemas';

export const WithdrawSettingsSchema = z.object({
  minAmount: z.number(),
  providerMaxAmount: z.record(PaymentProviderSchema, z.number().or(z.null())),
});

export const WithdrawalConfirmationSchema = z.unknown();
